import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import AboutHero from './components/AboutHero';
import Mission from './components/Mission';
import Values from './components/Values';
import WhyChooseUs from './components/WhyChooseUs';

export default function About() {
  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />
      <AboutHero />
      <Mission />
      <Values />
      <WhyChooseUs />
      <Footer />
    </div>
  );
}
